<template>
    <div class="container-with-elements">
        <p><label class="form-label">{{$t('utils.date')}}:</label> {{ elementDate | date }}</p>
        <hour-field
            ref="hourfield"
            :field="transfusionFields.date"
            :value="element.values.date"
            :prefix-field-name="prefix"
            :label="$t('utils.hour')"
            :errors="errors"
            field-name="date"
            time
            @input="addTimeToDate"
        />
        <select-as-radio-field
            v-model="element.values.transfusion_type"
            :field="transfusionFields.transfusion_type"
            :choices="transfusionFields.transfusion_type.choices"
            :prefix-field-name="prefix"
            :errors="errors"
            field-name="transfusion_type"
        />
        <input-field
            v-model="element.values.amount"
            :field="transfusionFields.amount"
            :prefix-field-name="prefix"
            :errors="errors"
            field-name="amount"
            type="number"
            :unit="element.values.transfusion_type === 'plasma' ? $t('utils.ml') : $tc('utils.unit', 2)"
        />
        <p v-if="serverErrors" class="invalid-feedback d-inline-block">{{ serverErrors }}</p>

        <create-cancel-buttons
            :ok-title="saveButtonTitle"
            :ok-function="checkAndSave"
            :cancel-title="$t('utils.cancel')"
            :cancel-function="close"
        />
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import InputField from "@/components/fields/InputField";
    import DetailSurgeryElementMixin from "@/components/surgery/detail/elements/DetailSurgeryElementMixin";
    import {required} from "vuelidate/lib/validators";
    import HourField from "@/components/fields/HourField";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import CreateCancelButtons from "@/components/surgery/detail/elements/CreateCancelButtons";


    export default {
        name: "DetailSurgeryTransfusion",
        components: {CreateCancelButtons, SelectAsRadioField, HourField, InputField},
        mixins: [DetailSurgeryElementMixin],
        computed: {
            ...mapState(['transfusionFields']),
            errors() {
                let errors = {};
                if (this.$v.element.values.transfusion_type.$error) {
                    errors['transfusion_type'] = [this.$t('error.required')];
                }
                if (this.$v.element.values.amount.$error) {
                    errors['amount'] = [this.$t('error.required')];
                }
                return errors;
            }
        },
        created() {
            const id = this.element.values.hasOwnProperty('id') ? this.element.values.id.toString() : 'new';
            this.prefix = 'transfusion-' + id;
            this.updateFunction = this.updateTransfusion;
            this.createFunction = this.createTransfusion;
        },
        methods: {
            ...mapActions([
                'updateTransfusion',
                'createTransfusion',
            ]),
            checkAndSave() {
                this.$refs.hourfield.createDate();
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.save();
                }
            },
        },
        validations: {
            element: {
                values: {
                    date: {
                        validDate: function () {
                            return !this.$refs.hourfield.$v.$invalid;
                        },
                    },
                    transfusion_type: {
                        required
                    },
                    amount: {
                        required,
                    }
                }
            }
        }
    };
</script>

<style scoped>

</style>